import { defineMessages } from "@edx/frontend-platform/i18n";

const messages = defineMessages({
  "events": {
    id: "pages.calendar.events",
    defaultMessage: "Events",
    description: "Title for events section"
  },
  "upcoming": {
    id: "pages.calendar.upcoming",
    defaultMessage: "Upcoming",
    description: "Title for upcoming events section"
  },
  "noEventsUpcoming": {
    id: "pages.calendar.noEventsUpcoming",
    defaultMessage: "No upcoming events",
    description: "Message shown when no upcoming events are found"
  },
  "noEventsToday": {
    id: "pages.calendar.noEventsToday",
    defaultMessage: "No events today",
    description: "Message shown when no events are today"
  },
  "today": {
    id: "pages.calendar.today",
    defaultMessage: "Today",
    description: "Text for today button"
  },
  "joinMeeting": {
    id: "components.eventCard.joinMeeting",
    defaultMessage: "Join Meeting",
    description: "Join Meeting"
  },
  "resume": {
    id: "components.recentActivityCard.resume",
    defaultMessage: "Resume",
    description: "Resume"
  },
  "free": {
    id: "components.blendxCard.free",
    defaultMessage: "Free",
    description: "Free"
  },
  "seeAll": {
    id: "components.recommendationsRow.seeAll",
    defaultMessage: "See All",
    description: "See All"
  },
  "programBadge": {
    id: "components.programCard.programBadge",
    defaultMessage: "Program",
    description: "Program badge"
  },
  "coursesCountLabel": {
    id: "components.programCard.coursesCountLabel",
    defaultMessage: "courses",
    description: "Courses count label"
  },
  "viewProgramDetails": {
    id: "components.programCard.viewProgramDetails",
    defaultMessage: "View Program Details",
    description: "View Program Details"
  },
  "inviteOnly": {
    id: "components.courseExploreCard.inviteOnly",
    defaultMessage: "Invite Only",
    description: "Badge text for invite only courses"
  },
  "alreadyEnrolled": {
    id: "components.courseExploreCard.alreadyEnrolled",
    defaultMessage: "Already Enrolled",
    description: "Button text when user is already enrolled"
  },
  "whatCanBeAchieved": {
    id: "components.courseExploreCard.whatCanBeAchieved",
    defaultMessage: "What can be achieved",
    description: "Title for achievements section"
  },
  "courseBadge": {
    id: "components.cartDrawer.courseBadge",
    defaultMessage: "Course",
    description: "Badge text for course type"
  },
  "removeButton": {
    id: "components.cartDrawer.removeButton",
    defaultMessage: "Remove",
    description: "Button text to remove item from cart"
  },
  "moveToWishlistButton": {
    id: "components.cartDrawer.moveToWishlistButton",
    defaultMessage: "Move to Wishlist",
    description: "Button text to move item to wishlist"
  },
  "subtotalLabel": {
    id: "components.cartDrawer.subtotalLabel",
    defaultMessage: "Subtotal",
    description: "Label for subtotal amount"
  },
  "cancelButton": {
    id: "components.cartDrawer.cancelButton",
    defaultMessage: "Cancel",
    description: "Button text to cancel"
  },
  "checkoutButton": {
    id: "components.cartDrawer.checkoutButton",
    defaultMessage: "Checkout",
    description: "Button text to proceed to checkout"
  },
  "courseImageAlt": {
    id: "components.courseDropdownCard.courseImageAlt",
    defaultMessage: "Course",
    description: "Alt text for course image"
  },
  "viewCourse": {
    id: "components.courseDropdownCard.viewCourse",
    defaultMessage: "View this course",
    description: "Link text to view course details"
  },
  "durationMetricHours": {
    id: "components.programCard.durationMetricHours",
    defaultMessage: "Hours",
    description: "Duration metric for hours"
  },
  "durationMetricDays": {
    id: "components.programCard.durationMetricDays",
    defaultMessage: "Days",
    description: "Duration metric for days"
  },
  "durationMetricWeeks": {
    id: "components.programCard.durationMetricWeeks",
    defaultMessage: "Weeks",
    description: "Duration metric for weeks"
  },
  "durationMetricMonths": {
    id: "components.programCard.durationMetricMonths",
    defaultMessage: "Months",
    description: "Duration metric for months"
  },
  "durationMetricYears": {
    id: "components.programCard.durationMetricYears",
    defaultMessage: "Years",
    description: "Duration metric for years"
  },
  "searchPlaceholder": {
    id: "components.miniTable.searchPlaceholder",
    defaultMessage: "Search...",
    description: "Placeholder text for search input"
  },
  "seeAllButton": {
    id: "components.miniTable.seeAllButton",
    defaultMessage: "See all",
    description: "Button text to see all items"
  },
  "loadingAlt": {
    id: "components.common.loadingAlt",
    defaultMessage: "Loading",
    description: "Alt text for loading image"
  },
  "profileBannerAlt": {
    id: "components.profileCard.bannerAlt",
    defaultMessage: "Profile background banner",
    description: "Alt text for profile banner image"
  },
  "supportTicketTitle": {
    id: "components.support.ticketTitle",
    defaultMessage: "Raise a Support Ticket",
    description: "Title for support ticket drawer"
  },
  "ticketTitleLabel": {
    id: "components.support.ticketTitleLabel",
    defaultMessage: "Ticket Title",
    description: "Label for ticket title input"
  },
  "ticketTitlePlaceholder": {
    id: "components.support.ticketTitlePlaceholder",
    defaultMessage: "Enter the title of the ticket",
    description: "Placeholder for ticket title input"
  },
  "problemTypeLabel": {
    id: "components.support.problemTypeLabel",
    defaultMessage: "Type of Problem",
    description: "Label for problem type dropdown"
  },
  "ticketDescriptionLabel": {
    id: "components.support.ticketDescriptionLabel",
    defaultMessage: "Ticket Description",
    description: "Label for ticket description input"
  },
  "issueType": {
    id: "components.support.issueType",
    defaultMessage: "Issue",
    description: "Issue type option"
  },
  "bugType": {
    id: "components.support.bugType",
    defaultMessage: "Bug",
    description: "Bug type option"
  },
  "featureType": {
    id: "components.support.featureType",
    defaultMessage: "Feature Request",
    description: "Feature request type option"
  },
  "otherType": {
    id: "components.support.otherType",
    defaultMessage: "Other",
    description: "Other type option"
  },
  "issuePlaceholder": {
    id: "components.support.issuePlaceholder",
    defaultMessage: "Explain the issue that you are facing in detail",
    description: "Placeholder for issue description"
  },
  "bugPlaceholder": {
    id: "components.support.bugPlaceholder",
    defaultMessage: "Explain the bug that you have found in detail",
    description: "Placeholder for bug description"
  },
  "featurePlaceholder": {
    id: "components.support.featurePlaceholder",
    defaultMessage: "If you have any feature request, please explain it in detail",
    description: "Placeholder for feature request description"
  },
  "otherPlaceholder": {
    id: "components.support.otherPlaceholder",
    defaultMessage: "Reach out to us with any other issues or feedback",
    description: "Placeholder for other type description"
  },
  "submitButton": {
    id: "components.common.submitButton",
    defaultMessage: "Submit",
    description: "Submit button text"
  },
  "ongoingCourses": {
    id: "components.progressCard.ongoingCourses",
    defaultMessage: "Ongoing Courses",
    description: "Title for ongoing courses count"
  },
  "completedCourses": {
    id: "components.progressCard.completedCourses",
    defaultMessage: "Completed Courses",
    description: "Title for completed courses count"
  },
  "completed": {
    id: "components.progressCard.completed",
    defaultMessage: "Completed",
    description: "Title for completion percentage"
  },
  "bestStreak": {
    id: "components.progressCard.bestStreak",
    defaultMessage: "Best Streak",
    description: "Title for best streak count"
  },
  "courseSummaryTitle": {
    id: "components.courseSummary.title",
    defaultMessage: "Course Summary",
    description: "Title for course summary table"
  },
  "courseColumnLabel": {
    id: "components.courseSummary.courseColumn",
    defaultMessage: "Course",
    description: "Label for course column"
  },
  "completionProgressLabel": {
    id: "components.courseSummary.completionProgressColumn",
    defaultMessage: "Completion Progress",
    description: "Label for completion progress column"
  },
  "attendanceLabel": {
    id: "components.courseSummary.attendanceColumn",
    defaultMessage: "Attendance",
    description: "Label for attendance column"
  },
  "actionsLabel": {
    id: "components.courseSummary.actionsColumn",
    defaultMessage: "Actions",
    description: "Label for actions column"
  },
  "viewAnalytics": {
    id: "components.courseSummary.viewAnalytics",
    defaultMessage: "View Analytics",
    description: "Text for view analytics button"
  },
  "courseEngagement": {
    id: "components.courseEngagement.title",
    defaultMessage: "Course Engagement",
    description: "Title for course engagement chart"
  },
  "today": {
    id: "components.courseEngagement.today",
    defaultMessage: "Today",
    description: "Text for today button"
  },
  "helpTitle": {
    id: "pages.help.title",
    defaultMessage: "Help & Support",
    description: "Title for help page"
  },
  "emailTitle": {
    id: "pages.help.emailTitle",
    defaultMessage: "Email us",
    description: "Title for email section"
  },
  "emailDescription": {
    id: "pages.help.emailDescription",
    defaultMessage: "Send us an email. We're here to help you.",
    description: "Description for email section"
  },
  "emailButton": {
    id: "pages.help.emailButton",
    defaultMessage: "Email to support",
    description: "Text for email button"
  },
  "callTitle": {
    id: "pages.help.callTitle",
    defaultMessage: "Call us",
    description: "Title for call section"
  },
  "callDescription": {
    id: "pages.help.callDescription",
    defaultMessage: "Monday to Friday, 9am to 5pm.",
    description: "Description for call section"
  },
  "callButton": {
    id: "pages.help.callButton",
    defaultMessage: "Call our team",
    description: "Text for call button"
  },
  "visitTitle": {
    id: "pages.help.visitTitle",
    defaultMessage: "Visit us",
    description: "Title for visit section"
  },
  "visitDescription": {
    id: "pages.help.visitDescription",
    defaultMessage: "Visit our office HQ.",
    description: "Description for visit section"
  },
  "visitButton": {
    id: "pages.help.visitButton",
    defaultMessage: "Get directions",
    description: "Text for visit button"
  },
  "addressModalTitle": {
    id: "pages.help.addressModalTitle",
    defaultMessage: "Address",
    description: "Title for address modal"
  },
  "viewEventTitle": {
    id: "pages.calendar.viewEventTitle",
    defaultMessage: "View Event",
    description: "Title for view event modal"
  },
  "viewDetails": {
    id: "pages.calendar.viewDetails",
    defaultMessage: "View Details",
    description: "Text for view details link"
  },
  "closeButton": {
    id: "pages.calendar.closeButton",
    defaultMessage: "Close",
    description: "Text for close button"
  },
  "goToLinkButton": {
    id: "pages.calendar.goToLinkButton",
    defaultMessage: "Go to Link",
    description: "Text for go to link button"
  },
  "showEventsButton": {
    id: "pages.calendar.showEventsButton",
    defaultMessage: "Show events",
    description: "Text for show events button"
  },
  "monthViewButton": {
    id: "pages.calendar.monthViewButton",
    defaultMessage: "Month",
    description: "Text for month view button"
  },
  "dayViewButton": {
    id: "pages.calendar.dayViewButton",
    defaultMessage: "Day",
    description: "Text for day view button"
  },
  "todayButton": {
    id: "pages.calendar.todayButton",
    defaultMessage: "Today",
    description: "Text for today button"
  },
  "descriptionTitle": {
    id: "pages.courseSingle.descriptionTitle",
    defaultMessage: "Description",
    description: "Title for description section"
  },
  "noDescriptionFound": {
    id: "pages.courseSingle.noDescriptionFound",
    defaultMessage: "No description found",
    description: "Text when no description is available"
  },
  "contentsTitle": {
    id: "pages.courseSingle.contentsTitle",
    defaultMessage: "Contents",
    description: "Title for contents section"
  },
  "noContentsFound": {
    id: "pages.courseSingle.noContentsFound",
    defaultMessage: "No contents found",
    description: "Text when no contents are available"
  },
  "removeFromCart": {
    id: "pages.courseSingle.removeFromCart",
    defaultMessage: "Remove from Cart",
    description: "Text for remove from cart button"
  },
  "addToCart": {
    id: "pages.courseSingle.addToCart",
    defaultMessage: "Add to Cart",
    description: "Text for add to cart button"
  },
  "removeFromWishlist": {
    id: "pages.courseSingle.removeFromWishlist",
    defaultMessage: "Remove from Wishlist",
    description: "Text for remove from wishlist button"
  },
  "addToWishlist": {
    id: "pages.courseSingle.addToWishlist",
    defaultMessage: "Add to Wishlist",
    description: "Text for add to wishlist button"
  },
  "topProgramsTitle": {
    id: "pages.programSingle.topProgramsTitle",
    defaultMessage: "Top Programs",
    description: "Title for top programs section"
  },
  "coursesLabel": {
    id: "pages.programSingle.coursesLabel",
    defaultMessage: "Courses",
    description: "Label for number of courses in a program"
  },
  "topCoursesTitle": {
    id: "pages.courseSingle.topCoursesTitle",
    defaultMessage: "Top Courses",
    description: "Title for top courses section"
  },
  "noCoursesFound": {
    id: "pages.courseSingle.noCoursesFound",
    defaultMessage: "No courses found",
    description: "Text when no courses are found"
  },
  "viewSourceLink": {
    id: "components.notes.viewSourceLink",
    defaultMessage: "View Source",
    description: "Text for view source link in notes"
  },
  "selectCourseMessage": {
    id: "components.notes.selectCourseMessage",
    defaultMessage: "Please select a course to view notes",
    description: "Message shown when no course is selected"
  },
  "noNotesFound": {
    id: "components.notes.noNotesFound",
    defaultMessage: "No notes found",
    description: "Message shown when no notes are found"
  },
  "reportProblem": {
    id: "components.aiTutor.reportProblem",
    defaultMessage: "Report a Problem",
    description: "Text for report a problem suggestion"
  },
  "profileBannerAlt": {
    id: "components.profileCardLarge.profileBannerAlt",
    defaultMessage: "Profile background banner",
    description: "Alt text for profile banner image"
  },
  "profilePictureAlt": {
    id: "components.profileCardLarge.profilePictureAlt",
    defaultMessage: "profile picture",
    description: "Alt text for profile picture"
  },
  "studentsBadge": {
    id: "components.profileCardLarge.studentsBadge",
    defaultMessage: "Students",
    description: "Text for students badge"
  },
  "accountSettingsButton": {
    id: "components.profileCardLarge.accountSettingsButton",
    defaultMessage: "Account Settings",
    description: "Text for account settings button"
  },
  "editProfileButton": {
    id: "components.profileCardLarge.editProfileButton",
    defaultMessage: "Edit Profile",
    description: "Text for edit profile button"
  },
  "cartTitle": {
    id: "components.cartDrawer.cartTitle",
    defaultMessage: "Cart",
    description: "Text for cart title"
  },
  "noProgramsFound": {
    id: "components.programTab.noProgramsFound",
    defaultMessage: "No programs found",
    description: "Message shown when no programs are found"
  },
  "gradeLabel": {
    id: "components.courseSummary.gradeLabel",
    defaultMessage: "Grade",
    description: "Label for grade column"
  },
  "letterGradeLabel": {
    id: "components.courseSummary.letterGradeLabel",
    defaultMessage: "Letter Grade",
    description: "Label for letter grade column"
  },
  "passingStatusLabel": {
    id: "components.courseSummary.passingStatusLabel",
    defaultMessage: "Status",
    description: "Label for passing status column"
  },
  "passValue": {
    id: "components.courseSummary.passValue",
    defaultMessage: "Completed",
    description: "Value for passing status"
  },
  "notPassingValue": {
    id: "components.courseSummary.notPassingValue",
    defaultMessage: "In Progress",
    description: "Value for not passing status"
  },
  "enrollFreeButton": {
    id: 'blendx.components.CartDrawer.enrollFreeButton',
    defaultMessage: 'Enroll in Free Courses',
    description: 'Button text for enrolling in free courses',
  },
  "paymentGatewayDisabled": {
    id: 'blendx.components.CartDrawer.paymentGatewayDisabled',
    defaultMessage: 'Payment gateway not enabled',
    description: 'Message shown when payment gateway is disabled and there are paid courses in cart',
  },
  "startDateInFuture": {
    id: "components.courseDropdownCard.startDateInFuture",
    defaultMessage: "Starts on {startDate}",
    description: "Text for start date in future"
  },
  "started": {
    id: "components.courseExploreCard.started",
    defaultMessage: "Started on {startDate}",
    description: "Text for started on date"
  },
  "notAvailable": {
    id: "components.courseExploreCard.notAvailable",
    defaultMessage: "Not Available For Enrollment",
    description: "Text for not available"
  },
  "tags": {
    id: "components.courseExploreCard.tags",
    defaultMessage: "Program Tags",
    description: "Text for program tags"
  }
});

export default messages;